module.exports = __webpack_public_path__ + "posture/static/img/cover-bg-ipad.6912d99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/cover-bg-ipad.png
// module id = q8a2
// module chunks = 1